import type { TypedStoreModule } from "@/types/vuex";
import type { RootState } from "..";
import type { ActionContext } from "vuex";
import { useApi } from '@/api';
import type { GetCrmMiscMetricsResponse, GetCrmMiscTemplateVariablesResponse } from "@/types/openapi-ts";

export interface CrmState {
  crmMetrics: GetCrmMiscMetricsResponse['payload'],
  crmTemplateVariables: GetCrmMiscTemplateVariablesResponse['payload'],
}


const state = {
  crmMetrics: null,
  crmTemplateVariables: null,
}

const getters = {
  crmMetrics: (state: CrmState) => state.crmMetrics,
  crmTemplateVariables: (state: CrmState) => state.crmTemplateVariables,
};


const mutations = {
  getMetrics(state: CrmState, payload: GetCrmMiscMetricsResponse['payload']) {
    state.crmMetrics = payload;
  },
  getTemplateVariables(state: CrmState, payload: GetCrmMiscTemplateVariablesResponse['payload']) {
    state.crmTemplateVariables = payload;
  },
};

const actions = {
  async getMetrics({ commit }: ActionContext<CrmState, RootState>) {
    const api = useApi();

    try {
      const hasPermission = true;
      if (hasPermission) {
        commit('getMetrics', []);
        const { data: { payload } } = await api.getCrmMetrics();
        commit('getMetrics', payload);
      }
    } catch (error) {
      commit('getMetrics', null);
    }
  },
  async getTemplateVariables({ commit }: ActionContext<CrmState, RootState>) {
    const api = useApi();

    try {
      const hasPermission = true;
      if (hasPermission) {
        commit('getTemplateVariables', []);
        const { data: { payload } } = await api.getCrmTemplateVariables();
        commit('getTemplateVariables', payload);
      }
    } catch (error) {
      commit('getTemplateVariables', null);
    }
  },
};

const storeModule = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};


export type CrmModule = TypedStoreModule<'crm', typeof storeModule>;

export default storeModule;